import {AvailableEmail} from '../AvailableEmail';
import {Factory as RequestSimpleFactory} from '../../../Backend/Rest/Request/Simple/Factory';
import {Connector as RestConnector} from '../../../Backend/Rest/Connector';
import {Injectable} from '@angular/core';
import {AsyncValidator, AsyncValidatorFn} from '@angular/forms';

@Injectable()
export class Factory {

    private requestSimpleFactory: RequestSimpleFactory = null;

    private restConnector: RestConnector = null;

    // ########################################

    constructor(
        requestSimpleFactory: RequestSimpleFactory,
        restConnector: RestConnector
    ) {
        this.requestSimpleFactory = requestSimpleFactory;
        this.restConnector = restConnector;
    }

    // ########################################

    public create(requestUrl: string, requestMethod: string, keyError: string): AvailableEmail {
        return new AvailableEmail(
            requestUrl,
            requestMethod,
            keyError,
            this.requestSimpleFactory,
            this.restConnector
        );
    }

    // ########################################
}
